export default __webpack_public_path__ + "static/media/brewdog-logo.d09f35fe.png";